var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CzUndoBar',{attrs:{"message":_vm.message,"error":!!_vm.failed,"action":_vm.failed ? _vm.$t('Retry').toString() : _vm.undoId ? _vm.$t('Undo').toString() : ''},on:{"action":function($event){_vm.failed ? _vm.retry() : _vm.undoLast()}}})}
var staticRenderFns = []

export { render, staticRenderFns }